import FJActionConstant from '../../constant/FJActionConstant';
import {
  FJModalAction,
  FJPreviewAction,
  FJProjectAction,
  FJTimeLineAction,
  FJToolbarAction,
  FJWatermarkAction,
  FJCloudAction
} from './FJRoot.action';
import FJLocalStore from '../../store/FJLocalStore';
import FJMediaStore from "../../store/FJMediaStore";
import FJCanvasStore from "../../store/FJCanvasStore";
import FJCoreConstant from "../../core/constant/FJCoreConstant";
import FJMedia from "../../store/FJMedia";
import FJUtil from "../../util/FJUtil";
// import FJEvent from "../../core/FJEvent";
import FJConfig from "../../config/FJConfig";
import FJTimelineStore from "fj-timeline";
import FJEventConstant from "../../constant/FJEventConstant";
import FJViewConstant from "../../constant/FJViewConstant";
import FJMessageStore from "../../store/FJMessageStore";
import FJMediaDownloadStore from "../../store/FJMediaDownloadStore";
import FJCloudStore from "../../store/FJCloudStore";
import FJNetworkStore from "../../store/FJNetworkStore";

function wrapDataForNewTimeline(type, fromType, value, options) {
  let {
    VIDEO,
    AUDIO,
    IMAGE,
  } = FJCoreConstant;

  let data = {value, type, fromType, media: null, ...options};
  switch (type) {
    case VIDEO:
    case AUDIO:
    case IMAGE:
      data.media = FJMediaStore.getMediaById(value);
      break;
    default:
  }

  return data;
}

let FJMediaAction = (function () {
  return {

    /**
     * @description 切换拖拽文件到页面
     * @param mode
     */
    changeDragModeAction: function (mode) {
      return (dispatch) => {
        // let dragMode = FJActionConstant.DRAG_FILE_MODE_RESOURCE
        dispatch({
          type: FJActionConstant.TOGGLE_DRAG_FILE_MODE,
          dragFileMode: mode,
        });
      };
    },

    /**
     * @description 模态框显示时不显示资源区域遮罩
     * @param visible
     * @returns {function(...[*]=)}
     */
    updateDragFileModeStateAction: function (visible) {
      return (dispatch) => {
        dispatch({
          type: FJActionConstant.HIDE_DRAG_FILE_MODE,
          isHideDragFileMode: visible
        })
      }
    },

    /**
     * @description 修改资源筛选类型
     * @param type
     * @returns {function(...[*]=)}
     */
    updateFiltrateMediaTypeAction: function (type) {
      return (dispatch) => {
        dispatch({
          type: FJActionConstant.UPDATE_FILTRATE_MEDIA_TYPE,
          filtrateMediaType: type
        })
      }
    },

    /**
     * @description 显示上传文件类型错误的模态框
     */
    mediaNotSupportAction: function () {
      return (dispatch) => {
        let data = {
          headerText: FJLocalStore._('not-support-file'),
          bodyText: FJLocalStore._('the-supported-files'),
          cancelType: 'cancel',
          hasCancel: false,
          submitText: FJLocalStore._('got-it')
        };
        dispatch(FJModalAction.showConfirmModalAction(data));
      }
    },

    /**
     * @description 显示上传文件类型错误的模态框
     */
    imageNotSupportAction: function () {
      return (dispatch) => {
        let data = {
          headerText: FJLocalStore._('logo-file-title'),
          bodyText: FJLocalStore._('logo-file-content'),
          hasCancel: false,
          submitText: FJLocalStore._('got-it')
        };
        dispatch(FJModalAction.showConfirmModalAction(data));
      }
    },

    /**
     * @description 显示上传文件大小错误的模态框
     * @returns {*}
     */
    mediaOverSizeAction: function () {
      return (dispatch) => {
        let data = {
          headerText: FJLocalStore._('media-over-size'),
          bodyText: FJLocalStore._('media-over-size-content'),
          cancelType: 'cancel',
          hasCancel: false,
          submitText: FJLocalStore._('got-it')
        };
        dispatch(FJModalAction.showConfirmModalAction(data));
      }
    },

    /**
     * @description 最小上传素材时长模态框
     * @param callback
     * @returns {function(...[*]=)}
     */
    mediaDurationAction: function (callback) {
      return (dispatch) => {
        let data = {
          headerText: FJLocalStore._('media-min-duration-text'),
          bodyText: FJLocalStore._('media-min-duration-content').replace('xxx', FJConfig.minLimitTime),
          cancelType: 'cancel',
          hasCancel: false,
          onCancel: (hide) => {
            hide();
            callback('cancel');
          },
          onSubmit: (hide) => {
            hide();
            callback('continue');
          },
          submitText: FJLocalStore._('got-it')
        };
        dispatch(FJModalAction.showConfirmModalAction(data));
      }
    },

    /**
     * @description 显示单次上传文件数量太多的模态框
     * @returns {*}
     */
    mediaOverNumAction: function (callback) {
      return (dispatch) => {
        let data = {
          headerText: FJLocalStore._('media-over-num'),
          bodyText: FJLocalStore._('media-over-num-content').replace('xxx', FJConfig.maxUploadCount),
          cancelType: 'cancel',
          hasCancel: false,
          onCancel: (hide) => {
            hide();
            callback('cancel');
          },
          onSubmit: (hide) => {
            hide();
            callback('continue');
          },
          submitText: FJLocalStore._('got-it')
        };
        dispatch(FJModalAction.showConfirmModalAction(data));
      }
    },

    /**
     * @description 点击添加资源到时间轴
     * @param type
     * @param fromType
     * @param value
     * @param options
     */
    addToTimeLineAction: function (type, fromType, value, options = {}) {
      return (dispatch) => {
        dispatch(FJPreviewAction.setVideoPauseAction());
        dispatch(this.updateMediaLibraryForNewTimelineAction(type, fromType, value, options));
        let data = wrapDataForNewTimeline(type, fromType, value, options);
        if (data.media && data.media.duration && data.media.duration < FJConfig.minLimitTime) {
          dispatch(this.openAddMediaTimeLimitAction());
        } else {
          let {ADD_TIMELINE, DECODE_MEDIA_TO_GRAPH} = FJCanvasStore.command;
          let graphId = FJCanvasStore.executeSync(ADD_TIMELINE, data);
          FJCanvasStore.executeSync(DECODE_MEDIA_TO_GRAPH);
          dispatch(this.updateViewAfterNewTimeline(graphId));

          if (options && options.bkType) {
            FJUtil.ealog('timeline_background_use', {category: options.bkType});
          }
        }
      };
    },

    /**
     * @description 拖拽资源到区域
     * @param type
     * @param fromType
     * @param value
     * @param options
     * @param options.duration 音视频需要传递自身的时长
     */
    dragToTimelineAction: function (type, fromType, value, options) {
      return (dispatch, getState) => {
        let {
          dragMode,
          eventType,
          cursorPoint,
          selfRect,
          bkType,
        } = options;

        let func = () => {
          const state = getState();
          const bricks = state.timeline.bricks;
          let {mainLayer, subLayer, subAudioLayer} = bricks;
          let boundingClientRects = [
            ...mainLayer,
            ...subLayer,
            ...subAudioLayer,
          ].map(brick => {
            let id = brick.id;
            let rect = document.querySelector(`[data-id='${id}']`).getBoundingClientRect();
            return {
              id,
              left: rect.left,
              top: rect.top,
              width: rect.width,
              height: rect.height,
            };
          });
          let info = {
            dragMode,
            eventType,
            cursorPoint,
            selfRect: {
              id: this._result,
              ...selfRect
            },
            containerRect: document.querySelector('[data-brick-container]').getBoundingClientRect(),
            mainTrackRect: document.querySelector(`[data-track=main-track]`).getBoundingClientRect(),
            processLineRect: document.querySelector(`[data-process-line]`).getBoundingClientRect(),
            boundingClientRects: boundingClientRects,
            isNew: true,
          };

          dispatch(FJTimeLineAction.dragTimeLineAction(this._result, info));

          // 初次添加时调用change，避免出现在副轴
          if (eventType === 'start') {
            dispatch(FJTimeLineAction.dragTimeLineAction(this._result, {...info, eventType: 'change'}));
          }
        };
        if (eventType === 'start') {
          dispatch(FJPreviewAction.setVideoPauseAction());
          let data = wrapDataForNewTimeline(type, fromType, value, options);
          if (data.media && data.media.duration && data.media.duration < FJConfig.minLimitTime) {
            dispatch(this.openAddMediaTimeLimitAction());
          } else {
            this._result = FJCanvasStore.executeSync(FJCanvasStore.command.ADD_SUBLAYER_TIMELINE, data); // 添加
            if (this._result) {
              const {SET_GRAPH_DELAY_BY_ID, DECODE_MEDIA_TO_GRAPH} = FJCanvasStore.command;
              dispatch(FJTimeLineAction.selectTimeLineAction(this._result)); // 选中

              // 为了保证拖动到时间轴的时候占位框的位置在鼠标对应位置之下
              let contLeft = document.querySelector('[data-brick-container]').getBoundingClientRect();
              let delay = (selfRect.left - contLeft.left) / FJTimelineStore.getUnitConversion();
              FJCanvasStore.executeSync(SET_GRAPH_DELAY_BY_ID, this._result, delay);
              FJCanvasStore.executeSync(DECODE_MEDIA_TO_GRAPH);

              dispatch(FJTimeLineAction.setDraggingStateAction(true));
              window.FJEvent.dispatch(FJEventConstant.TRIGGER_AUTO_EDGE_SCROLL, {});
            }
          }
        }
        func();
        window.FJEvent.dispatch(FJEventConstant.TRIGGER_AUTO_EDGE_SCROLL, {
          cursorPoint,
          horizontal: true,
          vertical: true,
          callback: func,
        });
        if (eventType === 'end') {
          // 判断是不是小于最小时间
          if (options && options.duration && options.duration < FJConfig.minLimitTime) {
            dispatch(this.deleteDragToTimelineAction());
            dispatch(this.openAddMediaTimeLimitAction());
          } else {
            dispatch(this.updateMediaLibraryForNewTimelineAction(type, fromType, value, options));
            dispatch(FJTimeLineAction.setDraggingStateAction(false));
            window.FJEvent.dispatch('updateSubLayer');

            dispatch(this.jumpToSelectedStartAction());
            dispatch(FJToolbarAction.updateToolbarAction());
            FJCanvasStore.executeSync(FJCanvasStore.command.DECODE_MEDIA_TO_GRAPH);

            setTimeout(() => {
              window.FJEvent.dispatch(FJEventConstant.TRIGGER_AUTO_EDGE_SCROLL, {});
            }, 10);

            if (bkType) {
              FJUtil.ealog('timeline_background_use', {category: bkType});
            }
          }
        }
        dispatch(FJTimeLineAction.updateSplitStatusAction());
      }
    },

    /**
     * @description 删除拖拽资源到时间轴区域又离开时间轴区域时已经添加到时间轴的资源
     * @returns {Function}
     */
    deleteDragToTimelineAction: function () {
      return (dispatch) => {

        if (this._result) {

          // 这里需要将快捷键的scope设置回去，对应拖入到时间线时触发的dragToTimelineAction
          FJUtil.toggleScope('end');
          FJCanvasStore.executeSync(FJCanvasStore.command.CLEAR_IGNORES_RENDER);
          dispatch(FJTimeLineAction.deleteTimelineAction(this._result, true));
          dispatch(FJTimeLineAction.setTimelineAdsorptionAction([]));
          this._result = null;
          window.FJEvent.dispatch(FJEventConstant.TRIGGER_AUTO_EDGE_SCROLL, {});

          // 拖动预览时会更新canvas的currentTime，如果在RERENDER前更新copy、paste、split则使用的是之前的currentTime
          FJCanvasStore.execute(FJCanvasStore.command.RERENDER).then(() => {
            dispatch(FJTimeLineAction.updateCopyStatusAction());
            dispatch(FJTimeLineAction.updatePasteStatusAction());
            dispatch(FJTimeLineAction.updateSplitStatusAction());
          });
        }
      }
    },

    /**
     * @description 应用于新增时间线后的更新
     * @param graphId
     * @return {function(*): void}
     */
    updateViewAfterNewTimeline: function (graphId) {
      return (dispatch) => {
        if (graphId) {
          dispatch(FJTimeLineAction.selectTimeLineAction(graphId));
          dispatch(this.jumpToSelectedStartAction());
          dispatch(FJToolbarAction.updateToolbarAction());
          dispatch(FJTimeLineAction.updateAllTimelineAction());
          dispatch(FJTimeLineAction.checkIsShowTimeLimitModalAction());
        }
      };
    },

    /**
     * @description 删除资源区的素材
     * @param id
     * @param onCancel
     * @param onSubmit
     */
    deleteMediaAction: function (id, onCancel = () => {
    }, onSubmit = () => {
    }) {
      return (dispatch) => {
        dispatch(FJPreviewAction.setVideoPauseAction());

        let mediaBeenUsedList = FJCanvasStore.executeSync(FJCanvasStore.command.GET_GRAPHS_BY_SOURCE_ID, id);
        if (mediaBeenUsedList.length > 0) { // 删除被占有素材
          let data = {
            headerText: FJLocalStore._('media-in-use'),
            bodyText: FJLocalStore._('your-choice-been-added'),
            onCancel: (callback) => {
              callback();
              onCancel();
            },
            onSubmit: (callback) => {
              callback();
              if (mediaBeenUsedList.length > 0) {
                // 删除时间轴中对应的资源
                dispatch(this.deleteMediaInTimelineAction([id]));
                dispatch(FJTimeLineAction.updateCopyStatusAction());
              }
              dispatch(this.confirmDeleteMediaAction([id], []));
              onSubmit();
            },
            submitDanger: true,
            cancelType: 'cancel',
            submitText: FJLocalStore._('delete')
          };
          dispatch(FJModalAction.showConfirmModalAction(data));
        } else { // 删除未被占有素材
          dispatch(this.confirmDeleteMediaAction([id], [], true));
          onSubmit();
        }
      }
    },

    /**
     * @description 批量删除资源区的素材
     * @returns {Function}
     */
    batchDeleteMediaAction: function () {
      return (dispatch, getState) => {
        const state = getState();
        const media = state.media;

        let mediaBeenUsedIdList = [];
        let mediaNotBeenUsedIdList = [];
        media.chooseMediaIdList.forEach(sourceId => {
          if (FJCanvasStore.executeSync(FJCanvasStore.command.GET_GRAPHS_BY_SOURCE_ID, sourceId).length > 0) {
            mediaBeenUsedIdList.push(sourceId);
          } else {
            mediaNotBeenUsedIdList.push(sourceId);
          }
        });
        dispatch(FJPreviewAction.setVideoPauseAction());
        let data = {
          headerText: FJLocalStore._('confirm-deletion'),
          bodyText: FJLocalStore._('delete-some-medium-content').replace('xxx', media.chooseMediaIdList.length),
          onCancel: null,
          onSubmit: (callback) => {
            callback();
            if (mediaNotBeenUsedIdList.length > 0) {
              if (mediaBeenUsedIdList.length > 0)
                dispatch(this.batchDeleteMediaBeenUsedAction(mediaBeenUsedIdList));
              dispatch(this.confirmDeleteMediaAction(mediaNotBeenUsedIdList, mediaBeenUsedIdList));
            } else {
              dispatch(this.batchDeleteMediaBeenUsedAction(mediaBeenUsedIdList))
            }
          },
          submitDanger: true,
          cancelType: 'cancel',
          submitText: FJLocalStore._('delete')
        };
        dispatch(FJModalAction.showConfirmModalAction(data));
      };
    },

    /**
     * @description 显示 批量删除的资源在时间线中已经使用弹窗
     * @param mediaBeenUsedIdList
     * @returns {Function}
     */
    batchDeleteMediaBeenUsedAction: function (mediaBeenUsedIdList) {
      return (dispatch) => {
        let data = {
          headerText: FJLocalStore._('media-in-use'),
          bodyText: FJLocalStore._('your-choice-been-added'),
          onCancel: null,
          onSubmit: (callback) => {
            callback();
            dispatch(this.deleteMediaInTimelineAction(mediaBeenUsedIdList));
            dispatch(this.confirmDeleteMediaAction(mediaBeenUsedIdList, []));
          },
          submitDanger: true,
          cancelType: 'cancel',
          submitText: FJLocalStore._('delete')
        };
        dispatch(FJModalAction.showConfirmModalAction(data));
      }
    },

    /**
     * @description 确认删除在时间线中 经使用的素材 （时间线）
     * @param deleteKeyList
     */
    deleteMediaInTimelineAction: function (deleteKeyList) {
      return (dispatch, getState) => {
        const state = getState();
        const selectedId = state.timeline.selectedId;

        FJCanvasStore.executeSync(FJCanvasStore.command.DELETE_GRAPHS_BY_SOURCE_IDS, deleteKeyList, selectedId, () => {
          dispatch(FJTimeLineAction.selectTimeLineAction(-1)); // 选中
        });
        dispatch(FJTimeLineAction.updateAllTimelineAction());
        dispatch(FJToolbarAction.updateToolbarAction());
      };
    },

    /**
     * @description 确认删除资源区的素材（资源区）
     * @param deleteKeyList
     * @param chooseKeyList
     * @param isNoUseInProject
     */
    confirmDeleteMediaAction: function (deleteKeyList, chooseKeyList, isNoUseInProject) {
      return (dispatch) => {

        // TODO 当前版本没有批量删除，所以这里只处理了deleteKeyList[0], 加入批量删除后需要处理这部分代码
        let isCloudMediaDelete = FJCloudStore.isCloudMedia(deleteKeyList[0]);
        const _deleteFunc = () => {
          let id = deleteKeyList[0];
          let media = FJMediaStore.getMediaById(id);
          let deleteMedia = {
            type: media.type,
            id: media.id,
            name: media.name
          };

          let __deleteMediaFunc = () => {
            let {SET_MEDIA_LIBRARY, CLEAR_UNDO} = FJCanvasStore.command;
            FJMediaStore.removeMediasFromLibrary(deleteKeyList);
            dispatch(this.updateMediasAction());
            dispatch(this.updateMediaChooseListAction(chooseKeyList));
            dispatch(this.checkHaveLinkMediaAction());
            FJCanvasStore.executeSync(SET_MEDIA_LIBRARY, FJMediaStore.getMedias());
            if (!deleteKeyList.every(id => !FJMediaStore.isUsedMediaId(id))) {
              FJCanvasStore.executeSync(CLEAR_UNDO);
            }

            if (FJTimelineStore.hasCopyCache()) {
              let {cache} = FJTimelineStore.getCopyCache();
              let sourceId = cache.sourceId;
              if (!deleteKeyList.every(id => id !== sourceId)) {
                FJTimelineStore.clearCopyCache();
                dispatch(FJTimeLineAction.setPasteStatusAction(false));
              }
            }

            if (FJCloudStore.checkMediaIsUploadIngById(id)) {

              // 中断上传
              FJNetworkStore.stopUploadMedia(deleteMedia);

              // 清除上传中的数据
              FJCloudStore.clearUploadMedia();
            }

            if (FJMediaDownloadStore.downloading.has(id)) {

              // 中断下载
              FJMediaDownloadStore.cancelMediaDownload(id);
            }

            FJCloudStore.deleteDoneMediaById(id);
            dispatch(FJCloudAction.doCheckWhenCloudSyncAction());
          };

          if (isCloudMediaDelete) {

            // 调删除云资源的接口
            dispatch(this.setDeleteMediaStatusByIdAction(id, true));
            FJNetworkStore.deleteCloudResourceById(id).then((res) => {
              if (res.force) {
                // 先屏蔽 后端去删除
                // FJNetworkStore.deleteS3Media(deleteMedia);
              }
              dispatch(this.setDeleteMediaStatusByIdAction(id, false));
              __deleteMediaFunc();
            }).catch((e) => {
              dispatch(this.setDeleteMediaStatusByIdAction(id, false));
              FJMessageStore.addMessage(FJLocalStore._('failed-to-delete-the-synced-file'), 'warning');
            });
          } else {
            __deleteMediaFunc()
          }
        };
        const dontShowCloudResourceDeleteModal = localStorage.getItem('dontShowCloudResourceDeleteModal');
        if (isNoUseInProject && isCloudMediaDelete && dontShowCloudResourceDeleteModal !== 'true') {
          let data = {
            headerText: FJLocalStore._('delete-this-file'),
            bodyText: FJLocalStore._('deleting-the-file-will-also-delete-the-cloud-backup'),
            onCancel: null,
            onSubmit: (callback, isNoShow) => {
              callback();
              if (isNoShow) {
                localStorage.setItem('dontShowCloudResourceDeleteModal', 'true');
              }
              _deleteFunc()
            },
            submitDanger: true,
            hasNoShowAgain: true,
            cancelType: 'cancel',
            submitText: FJLocalStore._('delete')
          };
          dispatch(FJModalAction.showConfirmModalAction(data));
        } else {
          _deleteFunc();
        }
      };
    },

    /**
     * @description 设置删除媒体的loading
     * @param id
     * @param bool
     * @returns {Function}
     */
    setDeleteMediaStatusByIdAction: function (id, bool) {
      return (dispatch, getState) => {
        const state = getState();
        let mediaList = JSON.parse(JSON.stringify(state.media.mediaList));
        mediaList.forEach(m => {
          if (m.id === id)
            m.isDeleteIng = bool;
        });
        dispatch({
          type: FJActionConstant.SET_MEDIA_LIST,
          data: [...mediaList]
        })
      }
    },

    /**
     * @description 选择资源区的素材
     * @param id
     * @param type 1:ctrl+鼠标左键；2鼠标左键
     * @param rate 初始线的位置
     */
    selectMediaAction: function (id, type, rate) {
      return (dispatch, getState) => {
        const state = getState();
        const media = state.media;
        let list = [...media.chooseMediaIdList];
        if (type === 1) {
          if (list.indexOf(id) === -1) {
            list.push(id);
          } else {
            list.splice(list.indexOf(id), 1);
          }
        } else {
          list = id ? [id] : [];
        }
        dispatch(this.setClickMediaIdAction(id));
        dispatch(this.setInitLinePositionAction(rate));
        dispatch(this.updateMediaChooseListAction(list));
      };
    },

    /**
     * @description 选中小组件 In Out
     * @param id
     */
    selectAnimationInOrOutAction: function (id) {
      return (dispatch, getState) => {
        let {RESOURCES_ANIMATION_INTRO, RESOURCES_ANIMATION_OUTRO} = FJViewConstant;
        let {showType} = getState().resource;
        switch (showType) {
          case RESOURCES_ANIMATION_INTRO:
            FJCanvasStore.executeSync(FJCanvasStore.command.SET_SVG_DATA, {introName: id});
            dispatch(this.setAnimationIntroSlot(id));
            break;
          case RESOURCES_ANIMATION_OUTRO:
            FJCanvasStore.executeSync(FJCanvasStore.command.SET_SVG_DATA, {outroName: id});
            dispatch(this.setAnimationOutroSlot(id));
            break;
          default:
        }
      }
    },

    setAnimationIntroSlot: function (id) {
      return {
        type: FJActionConstant.SET_ANIMATION_INTRO_SLOT,
        introSelectedId: id,
      }
    },

    setAnimationOutroSlot: function (id) {
      return {
        type: FJActionConstant.SET_ANIMATION_OUTRO_SLOT,
        outroSelectedId: id,
      }
    },

    retryMediaAction: function (id) {
      return (dispatch, getState) => {
        const {RETRY} = FJMedia.MediaStatus();
        let sourceId = id;
        if (!sourceId) {
          let graphId = getState().timeline.selectedId;
          let graph = FJCanvasStore.executeSync(FJCanvasStore.command.GET_GRAPHS_BY_ID, graphId);
          sourceId = graph.sourceId;
        }
        let media = FJMediaStore.getMediaById(sourceId);
        let status = media.getStatus();
        let {type, fromType} = media;
        if (status === RETRY) {
          FJMediaDownloadStore.downloadMedia(sourceId, '', {type, fromType, flush: true}).catch((e) => {
            console.log(e)
          });
        }
      };
    },

    /**
     * @description 添加网络资源
     * @param id
     * @param url 可以为空，为空的话会在此处去找url
     * @param type
     * @param fromType
     * @param options
     */
    addNetMediaAction: function (id, url, type, fromType, options) {
      return (dispatch, getState) => {
        const {SET_MEDIA_LIBRARY, DECODE_MEDIA_TO_GRAPH} = FJCanvasStore.command;
        const {DOWNLOADING, SUCCESS, RETRY} = FJMedia.MediaStatus();
        const {IMAGE, VIDEO, AUDIO} = FJCoreConstant;
        const filtrateMediaType = getState().media.filtrateMediaType;
        const filtrateMediaTypes = {
          video: VIDEO,
          image: IMAGE,
          audio: AUDIO,
        };
        let medias = FJMediaStore.getMedias();
        let media = medias.find(media => media.id === id);
        if (filtrateMediaType !== 'all' && filtrateMediaTypes[filtrateMediaType] !== type) {
          dispatch(this.updateFiltrateMediaTypeAction('all'))
        }
        dispatch(FJMediaAction.cutScrollAction(false));
        if (media) {
          FJMediaStore.mediasSort(id)
          dispatch(this.updateMediasAction());
        } else {
          media = FJMediaStore.addNetMediaToLibrary(id, type, fromType, options);
        }

        let status = media.getStatus();
        if (status === DOWNLOADING || status === RETRY) {
          media.setStatus(DOWNLOADING);
          FJMediaDownloadStore.downloadMedia(id, url, {type, fromType}).catch((e) => {
            console.log(e)
          });
        } else if (status === SUCCESS) {
          media.init().then(() => {
            FJCanvasStore.executeSync(DECODE_MEDIA_TO_GRAPH);
            dispatch(this.updateMediasAction());
          });
        }
        FJCanvasStore.executeSync(SET_MEDIA_LIBRARY, FJMediaStore.getMedias());
        dispatch(this.updateMediasAction());
      };
    },

    /**
     * @description 添加本地文件
     * @param files
     * @returns {Function}
     */
    addLocalMediaAction: function (files) {
      return async (dispatch, getState) => {
        let promises = [];
        let maxDuration = 0;
        let hasMusic = false;
        let medias = FJMediaStore.getMedias();
        let filtrateMediaType = getState().media.filtrateMediaType;
        let fileIsExists = false; // 判断文件是否存在相同
        for (let i = 0; i < files.length; i++) {
          let file = files[i];
          if (filtrateMediaType !== 'all' && file.type.indexOf(filtrateMediaType) === -1) {
            dispatch(this.updateFiltrateMediaTypeAction('all'))
          }
          dispatch(FJMediaAction.cutScrollAction(false))

          let id = await FJUtil.hashEncode(file);
          let nowMedia = medias.find(media => media.id === id);
          if (nowMedia && nowMedia.getStatus() !== FJMedia.MediaStatus().LINK) {
            // FJMediaStore.mediasSort(id)
            // dispatch(this.updateMediasAction());
            // dispatch(FJTimeLineAction.updateAllTimelineAction());
            // dispatch(FJToolbarAction.updateToolbarAction());
            // dispatch(this.checkHaveLinkMediaAction());
            // dispatch(this.selectMediaAction(id, 2, 1));
            fileIsExists = true;
            continue;
          }
          promises.push(new Promise((resolve, reject) => {
            FJMediaStore.addLocalMediaToLibrary(file, async () => {
              dispatch(this.updateMediasAction());
              dispatch(FJTimeLineAction.updateAllTimelineAction());
              dispatch(FJToolbarAction.updateToolbarAction());
              dispatch(this.checkHaveLinkMediaAction());

              FJCanvasStore.executeSync(FJCanvasStore.command.SET_MEDIA_LIBRARY, medias);
            }).then((media) => {
              try {
                // 埋点
                const {duration, type} = media;
                if (type === FJMedia.MediaType().VIDEO) {
                  maxDuration = Math.max(maxDuration, duration);
                }
                if (type === FJMedia.MediaType().AUDIO) {
                  hasMusic = true;
                }
                resolve();
              } catch (e) {
                console.log(e);

                // 这里只是用于处理统计，所以resolve，避免reject影响后续进程
                resolve();
              }
            }).catch(reject);
          }));
        }
        if (fileIsExists) {
          FJMessageStore.addMessage(FJLocalStore._('file-already-exists'), 'warning');
        }
        // dispatch(this.updateFiltrateMediaTypeAction('all'))


        let obj = {
          number: files.length,
          format: FJUtil.getFilesTypes(files),
          size: FJUtil.getFilesMaxSize(files),
        };

        try {
          await Promise.allSettled(promises);

          // 埋点
          if (maxDuration !== 0) {
            obj.duration = FJUtil.formatTime(maxDuration);
          }
          FJUtil.ealog('timeline_add media', obj);

          if (hasMusic) {
            FJUtil.ealog(
                'add music',
                {
                  button: 'browse your music',
                  "stock music retrieval method": '',
                  editor: "timeline"
                });
          }

        } catch (e) {
          console.log(e);
          dispatch(this.mediaNotSupportAction());
        }


        // 更新云存储的上传任务
        dispatch(FJCloudAction.doCheckWhenCloudSyncAction());
      }
    },

    /**
     * @description 更新所有媒体的界面
     * @return {{data: *, type: string}}
     */
    updateMediasAction: function () {
      let medias = FJMediaStore.getMedias();
      return {
        type: FJActionConstant.SET_MEDIA_LIST,
        data: medias.map(media => {
          return {
            id: media.id,
            type: media.type,
            fromType: media.fromType,
            status: media.getStatus(),
            downloadProgress: media.getProgress(),
            url: media.getMediaCache() && media.getMediaCache().getUrl(),
            duration: media.duration,
            name: media.name,
            thumbnail: media.thumbnail,
            cloudSyncStatus: media.cloudStatus,
            cloudSyncProgress: media.getUploadProgress()
          }
        }),
      }
    },

    /**
     * @descc 设置 hover 到素材上的id
     * @param id
     * @returns {{data: *, type: string}}
     */
    setHoverMediaIdAction: function (id) {
      return {
        type: FJActionConstant.SET_HOVER_MEDIA_ID,
        data: id,
      }
    },

    /**
     * @descc 设置 hover 到素材上的id
     * @param id
     * @returns {{data: *, type: string}}
     */
    setClickMediaIdAction: function (id) {
      return {
        type: FJActionConstant.SET_CLICK_MEDIA_ID,
        data: id,
      }
    },

    /**
     * @description 更新媒体的选中状态
     * @param list
     * @return {{data: *, type: string}}
     */
    updateMediaChooseListAction: function (list) {
      return {
        type: FJActionConstant.SET_CHOOSE_MEDIA_LIST,
        data: list,
      }
    },

    /**
     * @description 设置初始线的位置
     * @param rate 初始线的位置
     * @returns {{data: *, type: string}}
     */
    setInitLinePositionAction: function (rate) {
      return {
        type: FJActionConstant.SET_INITIAL_LINE_POSITION,
        data: rate,
      }
    },

    /**
     * @description 设置预览线的位置
     * @param rate  预览线的位置
     * @returns {{data: *, type: string}}
     */
    setPreviewLinePositionAction: function (rate) {
      return {
        type: FJActionConstant.SET_PREVIEW_LINE_POSITION,
        data: rate,
      }
    },

    abortDragTransitionAction: function () {
      return async (dispatch) => {
        FJCanvasStore.executeSync(FJCanvasStore.command.ABORT_DRAG_TRANSITION);
        dispatch(FJTimeLineAction.updateAllTimelineAction());
        dispatch(FJToolbarAction.updateToolbarAction());
      }
    },

    /**
     * @description 拖动转场到时间线
     */
    dragTransitionToTimelineAction: function (name, data) {
      return async (dispatch, getState) => {
        let {
          dragMode,
          eventType,
          cursorPoint,
          selfRect
        } = data;

        let func = () => {
          const state = getState();
          const {bricks} = state.timeline;
          let {mainLayer, subLayer, subAudioLayer} = bricks;
          let boundingClientRects = [
            ...mainLayer,
            ...subLayer,
            ...subAudioLayer,
          ].map(brick => {
            let id = brick.id;
            let rect = document.querySelector(`[data-id='${id}']`).getBoundingClientRect();
            return {
              id,
              left: rect.left,
              top: rect.top,
              width: rect.width,
              height: rect.height,
            };
          });
          let info = {
            dragMode,
            eventType,
            cursorPoint,
            selfRect: {
              id: this._result,
              ...selfRect
            },
            containerRect: document.querySelector('[data-brick-container]').getBoundingClientRect(),
            mainTrackRect: document.querySelector(`[data-track=main-track]`).getBoundingClientRect(),
            processLineRect: document.querySelector(`[data-process-line]`).getBoundingClientRect(),
            boundingClientRects: boundingClientRects,
          };
          let {
            transition,
            hasActiveTransition
          } = FJCanvasStore.executeSync(FJCanvasStore.command.DRAG_TRANSITION, name, info);

          // duration为0时说明没有时间线元素，这种情况下不进行转场的相关提示
          if (eventType === 'end') {
            if (transition) {
              window.FJEvent.dispatch(FJEventConstant.AUTO_POSITION_SELECTED_TIMELINE, transition.inKey);
            } else if (hasActiveTransition) {
              FJMessageStore.addMessage(FJLocalStore._('add-transition-error-tips'), 'warning');
            }
          }
          dispatch(FJTimeLineAction.updateAllTimelineAction());
          dispatch(FJToolbarAction.updateToolbarAction());
        };
        if (eventType === 'start') {
          dispatch(FJPreviewAction.setVideoPauseAction());
          window.FJEvent.dispatch(FJEventConstant.TRIGGER_AUTO_EDGE_SCROLL, {});
        }

        func();

        window.FJEvent.dispatch(FJEventConstant.TRIGGER_AUTO_EDGE_SCROLL, {
          cursorPoint,
          horizontal: true,
          vertical: true,
          callback: func,
        });
        if (eventType === 'end') {
          window.FJEvent.dispatch('updateSubLayer');
          window.FJEvent.dispatch(FJEventConstant.TRIGGER_AUTO_EDGE_SCROLL, {});
        }
      }
    },

    /**
     * @description 检查是否有需要relink的媒体资源
     * @param flush
     * @returns {Function}
     */
    checkHaveLinkMediaAction: function (flush) {
      return (dispatch) => {
        let medias = FJMediaStore.getMedias();
        if (!medias || medias.length === 0) {
          return
        }
        let list = [];
        let {LINK} = FJMedia.MediaStatus();
        medias.forEach(item => {
          if (item.getStatus() === LINK) {
            list.push({
              isLinked: false,
              isLoading: false,
              id: item.id,
              type: item.type,
              name: item.name,
            });
          }
        });
        dispatch(this.updateLinkMediaListAction(list));

        if (flush && list.length > 0) {
          dispatch(this.openLinkModalByUser());
        }
      }
    },

    /**
     * @description 更新link的list
     * @param list
     * @returns {{data: *, type: string}}
     */
    updateLinkMediaListAction: function (list) {
      return {
        type: FJActionConstant.UPDATE_LINK_MEDIA_LIST,
        data: list
      }
    },

    /**
     * @description 用户点击弹出relink的modal
     * @returns {Function}
     */
    openLinkModalByUser: function () {
      return (dispatch) => {
        dispatch(FJModalAction.setIsShowRelinkModalAction(true));
      }
    },

    /**
     * @description link资源
     * @param files
     * @param linkId
     * @param callback
     * @returns {Function}
     */
    linkMediasAction: function (files, linkId, callback) {
      return async (dispatch, getState) => {

        let linkMediaList = [...getState().media.linkMediaList];
        let needFile = [];
        let _files = [...files];
        // 过略掉不会上传的文件
        if (!linkId) {
          for (let i = 0; i < _files.length; i++) {
            let file = _files[i];
            let id = await FJUtil.hashEncode(file);
            if (linkMediaList.find((item) => item.id === id && !item.isLinked)) {
              needFile.push(file);
              let media = FJMediaStore.getMediaById(id);
              await media.setMediaCacheWithFile(file);
              media.setStatus(FJMedia.MediaStatus().SUCCESS);
              try {
                dispatch(this.setLinkMediaLoadingStatus(id, true));
                await media.init();
              } catch (e) {
                console.log(e)
                media.setStatus(FJMedia.MediaStatus().ERROR);
                dispatch(this.setLinkMediaLoadingStatus(id, false));
              }
            }
          }
        } else {
          for (let i = 0; i < _files.length; i++) {
            let file = _files[i];
            let id = await FJUtil.hashEncode(file);
            if (linkId === id) {
              needFile.push(file);
              let media = FJMediaStore.getMediaById(id);
              await media.setMediaCacheWithFile(file);
              media.setStatus(FJMedia.MediaStatus().SUCCESS);
              try {
                dispatch(this.setLinkMediaLoadingStatus(id, true));
                await media.init();
              } catch (e) {
                media.setStatus(FJMedia.MediaStatus().ERROR);
                dispatch(this.setLinkMediaLoadingStatus(id, false));
              }
            }
          }
        }

        if (needFile.length === 0) {
          dispatch(this.cutRelinkBtn());
          callback();
          return;
        }

        let successNum = 0;
        linkMediaList.forEach(linkMedia => {
          let mediaItem = FJMediaStore.getMediaById(linkMedia.id);
          let {SUCCESS, ERROR} = FJMedia.MediaStatus();
          if (mediaItem.getStatus() === SUCCESS || mediaItem.getStatus() === ERROR) {
            linkMedia.isLinked = true;
            linkMedia.isLoading = false;
            successNum++
          }
        });
        dispatch(this.updateLinkMediaListAction(linkMediaList));
        dispatch(this.updateMediasAction());

        if (linkMediaList.length === successNum) { // 全部link完
          dispatch(FJModalAction.setIsShowRelinkModalAction(false));
          dispatch(this.updateLinkMediaListAction([]));
        }

        dispatch(FJProjectAction.updateGraphsUrlAction());
        dispatch(this.cutRelinkBtn());
        dispatch(FJToolbarAction.updateToolbarAction());
        FJCanvasStore.execute(FJCanvasStore.command.RE_SEEK_AND_RENDER);

        // 更新云上传
        dispatch(FJCloudAction.doCheckWhenCloudSyncAction())
      };
    },

    /**
     * @description 切换 relink 显示按钮
     * @returns {{type: string}}
     */
    cutRelinkBtn: function () {
      return {
        type: FJActionConstant.CUT_LINK_BTN,
      }
    },

    /**
     * @description 是否置顶滚动条
     * @param boolean
     * @returns {{type: string, isTopScroll: *}}
     */
    cutScrollAction: function (boolean) {
      return {
        type: FJActionConstant.CUT_SCROLL_TYPE,
        isTopScroll: boolean
      }
    },

    /**
     * @description 设置link素材的loading状态
     * @param id
     * @param boolean
     * @returns {Function}
     */
    setLinkMediaLoadingStatus: function (id, boolean) {
      return (dispatch, getState) => {
        let linkMediaList = [...getState().media.linkMediaList];
        linkMediaList.forEach(item => {
          if (item.id === id) {
            item.isLoading = boolean;
          }
        });
        dispatch(this.updateLinkMediaListAction(linkMediaList));
      }
    },

    /**
     * @description 设置资源添加到时间轴后 设置进度条到指定位置
     * @param location 位置 0 -- 1
     * @returns {Function}
     */
    jumpToSelectedStartAction: function (location = 0.5) {
      return (dispatch) => {
        let {GET_SELECTED_GRAPH_CENTER_TIME} = FJCanvasStore.command;
        let nowTime = FJCanvasStore.executeSync(GET_SELECTED_GRAPH_CENTER_TIME, location);
        dispatch(FJPreviewAction.setVideoProcessAction('change', nowTime, {
          isPercent: false,
          flush: true,
          useThrottle: false,
        }));
      }
    },

    /**
     * @description 添加至时间轴的素材最小为0.4秒，小于0.4秒时无法添加并提示用户
     * @returns {Function}
     */
    openAddMediaTimeLimitAction: function () {
      return (dispatch) => {
        let data = {
          headerText: FJLocalStore._('minimum-length-limit'),
          bodyText: FJLocalStore._('minimum-length-limit-content').replace('xxx', FJConfig.minLimitTime),
          cancelType: 'cancel',
          hasCancel: false,
          submitText: FJLocalStore._('got-it')
        };
        dispatch(FJModalAction.showConfirmModalAction(data));
      }
    },

    updateAllDownloadDataAction: function () {
      return (dispatch) => {
        let {GET_WATERMARK, GET_ALL_GRAPHS} = FJCanvasStore.command;
        let {MEDIA_STATUS_SUCCESS, MEDIA_STATUS_RETRY, MEDIA_STATUS_DOWNLOADING} = FJViewConstant;
        let {downloading, downloadFail} = FJMediaDownloadStore;
        let {DOWNLOADING, SUCCESS, ERROR, RETRY} = FJMedia.MediaStatus();
        let {WATERMARK_IMAGE, DYNAMIC_LOGO, OVERLAY, STATIC_IMAGE} = FJCoreConstant;

        // 更新水印
        let watermark = FJCanvasStore.executeSync(GET_WATERMARK);
        let imageWatermark = watermark.getChild(WATERMARK_IMAGE);
        if (imageWatermark) {
          let sourceId = imageWatermark.sourceId;
          if (downloading.has(sourceId)) {
            dispatch(FJWatermarkAction.setWatermarkStatusAction(MEDIA_STATUS_DOWNLOADING));
            dispatch(FJWatermarkAction.setWatermarkProgressAction(downloading.get(sourceId)));
          } else if (downloadFail.has(sourceId)) {
            dispatch(FJWatermarkAction.setWatermarkStatusAction(MEDIA_STATUS_RETRY));
          } else {
            FJCanvasStore.executeSync(FJCanvasStore.command.RETRY_WATERMARK);
            dispatch(FJWatermarkAction.setWatermarkStatusAction(MEDIA_STATUS_SUCCESS));
          }
        }

        // 更新logo
        let graphs = FJCanvasStore.executeSync(GET_ALL_GRAPHS);
        graphs.forEach(graph => {
          let {type} = graph;
          if (type === DYNAMIC_LOGO || type === OVERLAY) {
            let images = graph.getGraphsByType(STATIC_IMAGE);
            images.forEach(image => {
              let sourceId = image.sourceId;
              if (sourceId && !downloading.has(sourceId) && !downloadFail.has(sourceId)) {
                FJCanvasStore.executeSync(FJCanvasStore.command.DECODE_MEDIA_TO_GRAPH);
              }
            });
          }
        });

        // 更新媒体库
        let updateFunc = (id, status, progress) => {
          FJMediaStore.updateMedia(id, {status, progress});
          FJCanvasStore.executeSync(FJCanvasStore.command.DECODE_MEDIA_TO_GRAPH);
          dispatch(this.updateMediasAction());
          dispatch(FJToolbarAction.updateToolbarAction());
          dispatch(FJTimeLineAction.updateAllTimelineAction());
        };
        FJMediaStore.getMedias().forEach(media => {
          let {id} = media;
          let curStatus = media.getStatus();
          if (downloading.has(id)) {
            updateFunc(id, DOWNLOADING, downloading.get(id));
          } else if (downloadFail.has(id)) {
            updateFunc(id, RETRY, 0);
          } else {
            if (curStatus === DOWNLOADING || curStatus === ERROR) {
              updateFunc(id, SUCCESS, 1);
            }
          }
        });
      };
    },

    /**
     * @description 新增时间线时先更新媒体库（主要服务于stock资源）
     * @param type
     * @param fromType
     * @param value
     * @param options
     */
    updateMediaLibraryForNewTimelineAction: function (type, fromType, value, options) {
      return (dispatch) => {
        const {STOCK, SELF} = FJMedia.MediaFromType();
        if (fromType === STOCK || fromType === SELF) {
          dispatch(this.addNetMediaAction(value, '', type, fromType, options));
        }
      };
    },

    /**
     * @description 显示indexeddb存储满的提示
     * @return {(function(*): void)|*}
     */
    showStorageFulledAction: function () {
      return (dispatch) => {
        dispatch(FJModalAction.showConfirmModalAction({
          headerText: FJLocalStore._('failed-to-sync'),
          bodyText: FJLocalStore._('your-system-drive-is-full'),
          hasCancel: false,
          submitText: FJLocalStore._('ok')
        }));
      };
    }
  }
})();

export default FJMediaAction;
